import { useRef, useState } from "react";
import { Button, Card, Toast } from "react-bootstrap";
import { IAgent } from "../../models/agent";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt, FaCopy } from 'react-icons/fa';

type Props = {
    agent: IAgent;
}

function EmbedChatbot({agent}: Props) {
    const [showToast, setShowToast] = useState(false)
    const codeRef = useRef<HTMLPreElement>(null);

    const baseURL = process.env.REACT_APP_URL;
    const chatbotURL = `${baseURL}chatagent/${agent.accessKey}`;

    const codeText = `<iframe
  src="${baseURL}chatagent/${agent.accessKey}"
  width="100%"
  style="height: 100%; min-height: 600px"
  frameborder="0">
</iframe>`;

    const handleCopy = () => {
        if (codeRef.current) {
            navigator.clipboard.writeText(codeRef.current.innerText)
                .then(() => {
                    setShowToast(true);
                });
        }
    };

    return (
        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444' }}>
            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '16px' }}>
                <div className="d-flex align-items-center">
                    <FaExternalLinkAlt size={20} style={{ color: '#fff', marginRight: '12px' }} />
                    <h5 style={{ color: '#fff', margin: 0 }}>Embed Chatbot</h5>
                </div>
            </Card.Header>
            <Card.Body style={{ padding: '24px' }}>
                <p style={{ color: '#ccc', marginBottom: '20px' }}>
                    Embed the chatbot directly into any webpage using an iframe. This provides a seamless integration experience.
                </p>

                {/* Preview URL */}
                <div style={{ marginBottom: '20px' }}>
                    <h6 style={{ color: '#fff', marginBottom: '8px' }}>Preview URL:</h6>
                    <div style={{ 
                        backgroundColor: '#1a1a1a', 
                        padding: '12px', 
                        borderRadius: '8px', 
                        border: '1px solid #555',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <Link
                            to={chatbotURL}
                            target="_blank"
                            style={{ 
                                color: '#007bff', 
                                textDecoration: 'none',
                                fontSize: '14px',
                                wordBreak: 'break-all'
                            }}
                        >
                            {chatbotURL}
                        </Link>
                        <Button
                            size="sm"
                            onClick={() => {
                                navigator.clipboard.writeText(chatbotURL);
                                setShowToast(true);
                            }}
                            style={{
                                backgroundColor: 'transparent',
                                borderColor: '#555',
                                color: '#fff',
                                marginLeft: '12px',
                                padding: '4px 8px'
                            }}
                        >
                            <FaCopy size={12} />
                        </Button>
                    </div>
                </div>

                {/* Embed Code */}
                <div>
                    <h6 style={{ color: '#fff', marginBottom: '8px' }}>Embed Code:</h6>
                    <div style={{ position: 'relative' }}>
                        <pre 
                            ref={codeRef} 
                            style={{
                                backgroundColor: '#1a1a1a',
                                color: '#fff',
                                padding: '16px',
                                borderRadius: '8px',
                                border: '1px solid #555',
                                overflowX: 'auto',
                                fontSize: '14px',
                                lineHeight: '1.4',
                                marginBottom: '0'
                            }}
                        >
                            {codeText}
                        </pre>
                        <Button 
                            onClick={handleCopy}
                            style={{
                                position: 'absolute',
                                top: '12px',
                                right: '12px',
                                backgroundColor: '#007bff',
                                borderColor: '#007bff',
                                color: '#fff',
                                padding: '8px 12px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <FaCopy size={14} />
                            Copy
                        </Button>
                    </div>
                </div>

                {/* Toast for copy confirmation */}
                <Toast
                    onClose={() => setShowToast(false)}
                    show={showToast}
                    delay={2000}
                    autohide
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        zIndex: 1000,
                        backgroundColor: '#2d2d2d',
                        borderColor: '#007bff'
                    }}
                >
                    <Toast.Body style={{ color: '#007bff' }}>
                        Code copied to clipboard!
                    </Toast.Body>
                </Toast>
            </Card.Body>
        </Card>
    );
}

export default EmbedChatbot